var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    "aria-label": "search-icon",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m33.62 30.208-5.453-5.452a1.31 1.31 0 0 0-.93-.383h-.892a11.3 11.3 0 0 0 2.407-7C28.752 11.092 23.66 6 17.376 6S6 11.09 6 17.374c0 6.283 5.092 11.374 11.376 11.374 2.641 0 5.07-.897 7-2.406v.891c0 .35.137.684.383.93l5.453 5.451a1.307 1.307 0 0 0 1.854 0l1.548-1.547a1.32 1.32 0 0 0 .005-1.86m-16.244-5.835c-3.867 0-7-3.128-7-7 0-3.865 3.128-6.998 7-6.998 3.866 0 7 3.127 7 6.999 0 3.866-3.128 7-7 7"
  })));
};
export default SvgSearch;